/**
 * A server refusal in a dialog's words. The edge functions refuse a body field
 * as `"<field>: <reason>"` (`supabase/functions/_shared/app/validation.ts`):
 * a dialog shows the reason under its own field, without the column name.
 * Anything else is a sentence of its own. The phone-number and Cal.com dialogs
 * read refusals through these two, as the Angular dashboard does through its
 * own `FIELD_REFUSAL_PATTERN` and `sentence()`.
 */

/** No answer at all — offline, say. The browser's own words for it ("Failed to fetch") help nobody. */
export const UNREACHABLE = "Couldn't reach the server. Check your connection and try again.";

/** `"<field>: <reason>"`: the body field a refusal is about, then why. */
export const FIELD_REFUSAL_PATTERN = /^([a-z_]+): (.+)$/;

/** The server's words as a sentence: a capital first, a full stop last — never two. */
export function sentence(text: string): string {
  const capitalised = `${text.charAt(0).toUpperCase()}${text.slice(1)}`;
  return /[.!?]$/.test(capitalised) ? capitalised : `${capitalised}.`;
}
